import {IRoutesProvider } from 'Shared/Routes';
import { GeneralRedirect } from 'Shared/Routes';
import { sharedLoginRoutes } from 'Shared/routes/LoginRoutes';
import { lazy } from 'solid-js';


export class ArtistRoutes implements IRoutesProvider
{
	/* 
		It might be better to support direct login via https://profile.voshub.com  
		Note that any users going to the venue backends would need to login again.
		Would probably want to add explanations to any access denied messages.
		
	*/

	routes()
	{
		return ([
			/* Venues point to this to login too */
			...this.loginRoutes(),

			{
				path: '/',
				component: () => <GeneralRedirect url='/manager'/>,
			},
			{
				path: '/manager',
				component: lazy(() => import('Shared/artists/ManagerPage')),
			},
			{
				path: '/profile/:id',
				component: lazy(() => import('Shared/artists/ProfilePage')),
			},
			{
				path: '/user',
				component: lazy(() => import('Shared/users/UserPage')),
			}

//TODO share these links between venues and artists (eg common parent)			
		
//			'/*':	FrontendPageNotFound
		]);
	}

	loginRoutes()
	{
		return ([
			{
				path: '/login',
				component: () => <GeneralRedirect url='/manager'/>,
			},
			...sharedLoginRoutes()
		]);
	}

//TODO maybe trim trailing / from all...
}

